(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire716c"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire716c"] = parcelRequire;
}
parcelRequire.register("kALAC", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $efdc15c1a4c8141a$export$6503ec6e8aabbaf; }, function (v) { return $efdc15c1a4c8141a$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $efdc15c1a4c8141a$export$f7ad0328861e2f03; }, function (v) { return $efdc15c1a4c8141a$export$f7ad0328861e2f03 = v; });
var $efdc15c1a4c8141a$export$6503ec6e8aabbaf;
var $efdc15c1a4c8141a$export$f7ad0328861e2f03;
"use strict";
var $efdc15c1a4c8141a$var$mapping = {};
function $efdc15c1a4c8141a$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$efdc15c1a4c8141a$var$mapping[keys[i]] = pairs[keys[i]];
}
function $efdc15c1a4c8141a$var$resolve(id) {
    var resolved = $efdc15c1a4c8141a$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$efdc15c1a4c8141a$export$6503ec6e8aabbaf = $efdc15c1a4c8141a$var$register;
$efdc15c1a4c8141a$export$f7ad0328861e2f03 = $efdc15c1a4c8141a$var$resolve;

});

parcelRequire.register("gDbQv", function(module, exports) {



module.exports = (parcelRequire("OhpYH"))((parcelRequire("g6D7N")).getBundleURL("3lEk9") + (parcelRequire("kALAC")).resolve("fKBxW")).then(()=>parcelRequire("kR50v"));

});
parcelRequire.register("OhpYH", function(module, exports) {
"use strict";

var $dOM5O = parcelRequire("dOM5O");
module.exports = $dOM5O(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRequire.register("dOM5O", function(module, exports) {
"use strict";
var $a0f54011faa0e7af$var$cachedBundles = {};
var $a0f54011faa0e7af$var$cachedPreloads = {};
var $a0f54011faa0e7af$var$cachedPrefetches = {};
function $a0f54011faa0e7af$var$getCache(type) {
    switch(type){
        case "preload":
            return $a0f54011faa0e7af$var$cachedPreloads;
        case "prefetch":
            return $a0f54011faa0e7af$var$cachedPrefetches;
        default:
            return $a0f54011faa0e7af$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a0f54011faa0e7af$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRequire.register("g6D7N", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $bb9b8e3b319f2ce9$export$bdfd709ae4826697; }, function (v) { return $bb9b8e3b319f2ce9$export$bdfd709ae4826697 = v; });
var $bb9b8e3b319f2ce9$export$bdfd709ae4826697;
var $bb9b8e3b319f2ce9$export$c9e73fbda7da57b6;
var $bb9b8e3b319f2ce9$export$5a759dc7a1cfb72a;
"use strict";
var $bb9b8e3b319f2ce9$var$bundleURL = {};
function $bb9b8e3b319f2ce9$var$getBundleURLCached(id) {
    var value = $bb9b8e3b319f2ce9$var$bundleURL[id];
    if (!value) {
        value = $bb9b8e3b319f2ce9$var$getBundleURL();
        $bb9b8e3b319f2ce9$var$bundleURL[id] = value;
    }
    return value;
}
function $bb9b8e3b319f2ce9$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $bb9b8e3b319f2ce9$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $bb9b8e3b319f2ce9$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $bb9b8e3b319f2ce9$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$bb9b8e3b319f2ce9$export$bdfd709ae4826697 = $bb9b8e3b319f2ce9$var$getBundleURLCached;
$bb9b8e3b319f2ce9$export$c9e73fbda7da57b6 = $bb9b8e3b319f2ce9$var$getBaseURL;
$bb9b8e3b319f2ce9$export$5a759dc7a1cfb72a = $bb9b8e3b319f2ce9$var$getOrigin;

});


parcelRequire.register("5jIeY", function(module, exports) {



module.exports = (parcelRequire("OhpYH"))((parcelRequire("g6D7N")).getBundleURL("3lEk9") + (parcelRequire("kALAC")).resolve("jKtKc")).then(()=>parcelRequire("7RYid"));

});

parcelRequire.register("8euZe", function(module, exports) {



module.exports = (parcelRequire("OhpYH"))((parcelRequire("g6D7N")).getBundleURL("3lEk9") + (parcelRequire("kALAC")).resolve("k7hNH")).then(()=>parcelRequire("8qEVG"));

});

parcelRequire.register("2pD5u", function(module, exports) {



module.exports = (parcelRequire("OhpYH"))((parcelRequire("g6D7N")).getBundleURL("3lEk9") + (parcelRequire("kALAC")).resolve("kqBcN")).then(()=>parcelRequire("iUK9m"));

});

parcelRequire.register("9TiXj", function(module, exports) {



module.exports = (parcelRequire("OhpYH"))((parcelRequire("g6D7N")).getBundleURL("3lEk9") + (parcelRequire("kALAC")).resolve("lJT3i")).then(()=>parcelRequire("7cSQs"));

});

var $50dce092e63238ca$exports = {};

(parcelRequire("kALAC")).register(JSON.parse('{"3lEk9":"base.b7932d1b.js","fKBxW":"faq.8ba0402f.js","jKtKc":"form.3013ecce.js","k7hNH":"legacy.b3f9eb76.js","kqBcN":"swiper.31566e47.js","lJT3i":"map.e1060923.js"}'));


(parcelRequire("gDbQv"));

(parcelRequire("5jIeY"));

(parcelRequire("8euZe"));

(parcelRequire("2pD5u"));

(parcelRequire("9TiXj"));
(()=>{
    const kwBody = document.querySelector("body.kw-body");
    const callbackBtn = document.getElementById("kw_cta_callback_mob");
    const ctaPhotoBtn = document.getElementById("kw_cta_photo");
    const callbackDialog = document.getElementById("kw_dialog_callback");
    const videoDialog = document.getElementById("kw_dialog_video");
    const videoWrap = videoDialog === null || videoDialog === void 0 ? void 0 : videoDialog.querySelector("div.kw-dialog_video-wrap");
    const videoCloseBtn = videoDialog.querySelector("button.kw-button_close");
    const ctaCloseBtn = callbackDialog === null || callbackDialog === void 0 ? void 0 : callbackDialog.querySelector("button.kw-button_close");
    const bodyScroll = (force = true)=>{
        if (force) kwBody.classList.remove("kw-noscroll");
        else kwBody.classList.add("kw-noscroll");
    };
    const dialogClose = (dialog, cb = ()=>{})=>{
        cb();
        bodyScroll(true);
        dialog.close();
    };
    const detectOutsideDialogClick = (e, dialog, cb = ()=>{})=>{
        e.stopPropagation();
        const rect = dialog === null || dialog === void 0 ? void 0 : dialog.getBoundingClientRect();
        if (!rect) return;
        if (e.clientY < rect.top || e.clientY > rect.bottom || e.clientX < rect.left || e.clientX > rect.right) dialogClose(dialog, cb);
    };
    const videoDialogReset = ()=>{
        videoWrap.innerHTML = "";
    };
    const showCtaDialog = (e)=>{
        e.stopPropagation();
        bodyScroll(false);
        callbackDialog === null || callbackDialog === void 0 ? void 0 : callbackDialog.showModal();
    };
    ctaPhotoBtn.onclick = showCtaDialog;
    callbackBtn.onclick = showCtaDialog;
    videoCloseBtn.onclick = (e)=>{
        e.stopPropagation();
        dialogClose(videoDialog, videoDialogReset);
    };
    ctaCloseBtn.onclick = (e)=>{
        e.stopPropagation();
        dialogClose(callbackDialog);
    };
    videoDialog.onclick = (e)=>detectOutsideDialogClick(e, videoDialog, videoDialogReset);
    callbackDialog.onclick = (e)=>detectOutsideDialogClick(e, callbackDialog);
    const videoBlocks = document.querySelectorAll(".kw-video");
    videoBlocks.forEach((item)=>{
        item.onclick = ()=>{
            var _item_querySelector, _item_querySelector_content;
            const iframe = (_item_querySelector = item.querySelector("template")) === null || _item_querySelector === void 0 ? void 0 : (_item_querySelector_content = _item_querySelector.content) === null || _item_querySelector_content === void 0 ? void 0 : _item_querySelector_content.cloneNode(true);
            if (!iframe) return;
            bodyScroll(false);
            videoWrap.innerHTML = "";
            videoWrap.appendChild(iframe);
            videoDialog.showModal();
        };
    });
    const openMenu = ()=>{
        var _document_querySelector, _document_querySelector_classList;
        (_document_querySelector = document.querySelector("nav.kw-nav")) === null || _document_querySelector === void 0 ? void 0 : (_document_querySelector_classList = _document_querySelector.classList) === null || _document_querySelector_classList === void 0 ? void 0 : _document_querySelector_classList.toggle("show");
    };
    const navClose = document.getElementById("kw_nav_close");
    const menuBtn = document.getElementById("kw_mob_menu");
    const menuBtnLegacy = document.querySelector(".app-header .menu_btn");
    menuBtn === null || menuBtn === void 0 ? void 0 : menuBtn.onclick = openMenu;
    menuBtnLegacy === null || menuBtnLegacy === void 0 ? void 0 : menuBtnLegacy.onclick = openMenu;
    navClose === null || navClose === void 0 ? void 0 : navClose.onclick = openMenu;
    const fire = (msg, mod = "success")=>{
        if (mod == "success") {
            const dialogList = document.getElementsByTagName("dialog");
            for (const el of dialogList)el === null || el === void 0 ? void 0 : el.close();
        }
        const newDiv = document.createElement("div");
        newDiv.innerHTML = `<span class="kw-callback-msg ${mod}">${msg}</span>`;
        videoWrap.innerHTML = "";
        videoWrap.appendChild(newDiv);
        bodyScroll(false);
        videoDialog.showModal();
    };
    document.addEventListener("fetchit:success", (e)=>{
        const { response: response  } = e.detail;
        fire(response.message);
    });
    document.addEventListener("fetchit:error", (e)=>{
        const { response: response  } = e.detail;
        fire(response.message, "error");
    });
})();

})();
//# sourceMappingURL=base.b7932d1b.js.map
